import React, { useCallback, useMemo, useRef, useState } from 'react';
import CONFIG from '../config.js';
import {useWebSocket} from '../util/websocket.js';
import { useQueryParam } from '../util/react_hooks.js';

const WebrtcParticipant = ()=>{
    let [participantId] = useQueryParam('id');
    console.log({participantId});
    let [data, setData] = useState('');
    let hostPeerRef = useRef(null);
    let startConnection = useCallback(async (ws, peerId)=>{
        let peer = new RTCPeerConnection({
            iceServers: [{urls: 'stun:stun.l.google.com:19302'}],
        });
        hostPeerRef.current = peer;
        peer.onicecandidate = ev=>{
            if (!ev.candidate)
                return;
            ws.sendEvent('signal', {to: peerId, from: participantId, payload: ev.candidate});
        };
        let offer = await peer.createOffer();
        await peer.setLocalDescription(new RTCSessionDescription(offer));
        ws.sendEvent('signal', {to: peerId, from: participantId, payload: offer});
        peer.ondatachannel = ev=>{
            console.log('got data channel', ev);
            ev.channel.onmessage = e=>setData(e.data);
        };
    }, [participantId]);
    let actionMap = useMemo(()=>({
        connected: async (ws, data)=>{
            console.log('connected', data);
            let {type, id} = data;
            if (type=='host'&&!hostPeerRef.current)
                await startConnection(ws, id);
        },
        disconnected: (__, data)=>{
            console.log('disconnected', data);
            let {type} = data;
            if (type!='host')
                return;
            hostPeerRef.current?.close();
            hostPeerRef.current = null;
        },
        signal: async (ws, data)=>{
            console.log('signal', data);
            let {from, payload} = data;
            let peer = hostPeerRef.current;
            if (!peer)
                return;
            if (payload.type=='offer') {
                await peer.setRemoteDescription(new RTCSessionDescription(payload));
                let answer = await peer.createAnswer();
                await peer.setLocalDescription(answer);
                ws.sendEvent('signal', {to: from, from: participantId, payload: answer});
            } else if (payload.type=='answer') {
                // await peer.setRemoteDescription(new RTCSessionDescription(payload));
            } else if (payload.candidate) {
                await peer.addIceCandidate(new RTCIceCandidate(payload));
            }
        },
    }), [startConnection, participantId]);
    useWebSocket({
        url: `${CONFIG.WS_URL}webrtc?type=participant&id=${participantId}`,
        actionMap,
        retry: true,
        enable: !!participantId,
    });
    return <div>{data}</div>;
};

export default WebrtcParticipant;
